import { useTranslation } from 'react-i18next'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const isZh = i18n.language?.startsWith('zh')

  return (
    <button
      className="fixed top-4 right-4 z-50 px-3 py-1.5 rounded-md text-[12px] font-semibold tracking-wide cursor-pointer transition-colors"
      style={{
        background: 'rgba(0,0,0,0.4)',
        border: '1px solid rgba(255,255,255,0.12)',
        color: 'rgba(220,210,240,0.7)',
        backdropFilter: 'blur(8px)',
      }}
      onClick={() => i18n.changeLanguage(isZh ? 'en' : 'zh')}
    >
      {isZh ? 'EN' : '中文'}
    </button>
  )
}
